import React from "react";

const items = [
  {
    icon: "/assets/fees-orange.svg",
    title: `No contracts or <br /> hidden fees`,
    description: `Change or cancel anytime`,
  },
  {
    icon: "/assets/network-orange.svg",
    title: "Triple network access at single network prices",
    description: `Up to 40% less than <br /> competitors`,
  },
  {
    icon: "/assets/identity-protection-orange.svg",
    title: "Identity and financial protection included FREE",
    description: "Save $15-50/month compared to standalone services",
  },
  {
    icon: "/assets/security-orange.svg",
    title: "Free Upgrade to Complete Security",
    // description: `For just $10/month more <span class="2xl:whitespace-nowrap">(individual) or $20/month (family)</span>`,
    description: `Includes free upgrade to Aura complete protection plan`,
  },
];

export const ValueYouWontFind = () => {
  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
      <div className="w-full max-w-[85.5rem] bg-[#F8F0EA] px-4 sm:px-5 md:px-6 lg:px-9 xl:px-12 2xl:px-[3.375rem] py-8 sm:py-10 md:py-16 lg:py-20 2xl:py-[6.25rem] rounded-3xl md:rounded-[2rem] mx-auto">
        <div className="text-center space-y-0.5 sm:space-y-1 mb-5 sm:mb-8 md:mb-11 lg:mb-[3.125rem]">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
            Value You Won't Find Anywhere Else
          </h2>
          <p className="text-[#1D1D1B] text-sm sm:text-[0.925rem] md:text-base lg:text-lg font-normal leading-5 sm:leading-6 md:leading-7">
            VLE stands for value, and that's what VLE Mobile delivers to
            platform drivers:
          </p>
        </div>
        <ul className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4 sm:gap-4 lg:gap-5">
          {items.map((item, index) => (
            <li
              key={index}
              className="flex flex-col gap-6 sm:gap-8 md:gap-10 lg:gap-12 2xl:gap-14 bg-white [@media(min-width:1454px)]:max-h-[18.125rem] p-5 sm:p-6 md:p-7 lg:p-[1.875rem] pb-[1.315rem] sm:pb-[1.565rem] md:pb-[1.815rem] lg:pb-[1.94rem] border border-[#E9EAEB] rounded-xl md:rounded-2xl"
            >
              <div className="shrink-0 flex items-center justify-center bg-white size-12 sm:size-14 lg:size-16 border border-[#EAECF5] rounded-full mx-0.5">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="size-6 sm:size-7 lg:size-8 shrink-0"
                />
              </div>
              <div className="flex-1 flex flex-col gap-1 sm:gap-1.5 lg:gap-2">
                <h3
                  className="font-mobile text-[#1D1D1B] text-lg sm:text-xl lg:text-[1.375rem] font-medium leading-[1.375rem] sm:leading-6 lg:leading-7"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <p
                  className="text-[#475467] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-[1.125rem] sm:leading-5 md:leading-[1.4rem] tracking-[-0.02rem]"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
